export default __webpack_public_path__ + "static/media/service-warning.4ecab9fc.svg";